import { apiListSensors } from "apis/SensorApi";
import { generateClient } from "aws-amplify/api";

const client = generateClient();

const GET_TRAFFIC_SUMMARIES = `
  query GetTrafficSummaries($timeUnit: String!, $selectedDateTime: AWSDateTime!, $sensorIds: [String!]!) {
    getTrafficSummaries(timeUnit: $timeUnit, selectedDateTime: $selectedDateTime, sensorIds: $sensorIds) {
      sensorId
      bucketTime
      totalCars
      totalPedestrians
      totalTraffic
    }
  }
`;

export const trafficCache = {
  sensorsPromise: null,
  trafficPromise: null,
  initialDateTime: null, 
  fetchTime: null, 
};

export const clearTrafficCache = () => {
  trafficCache.sensorsPromise = null;
  trafficCache.trafficPromise = null;
  trafficCache.initialDateTime = null;
  trafficCache.fetchTime = null; 
};

export const prefetchTrafficPageData = (forceRefresh = false) => {
  if (forceRefresh) {
    clearTrafficCache();
  }

  if (!trafficCache.sensorsPromise) {
    trafficCache.sensorsPromise = apiListSensors().then((res) => {
      if (res.success && res.data && res.data.items) {
        return res.data.items.filter((sensor) => sensor.data?.trafficVolumeFeature === true);
      }
      return [];
    }).catch(err => {
      console.error("Prefetch Sensors Error:", err);
      trafficCache.sensorsPromise = null; 
      throw err;
    });
  }

  if (!trafficCache.trafficPromise) {
    const now = new Date();
    now.setMinutes(Math.floor(now.getMinutes() / 10) * 10, 0, 0);
    
    trafficCache.initialDateTime = now.toISOString(); 
    trafficCache.fetchTime = Date.now(); 
    
    trafficCache.trafficPromise = trafficCache.sensorsPromise.then((sensors) => {
      if (sensors.length === 0) return [];
      
      const sensorIds = sensors.map((s) => s.id);
      return client.graphql({
        query: GET_TRAFFIC_SUMMARIES,
        variables: { 
          timeUnit: "DAILY", 
          selectedDateTime: trafficCache.initialDateTime, 
          sensorIds 
        },
      }).then((res) => res.data.getTrafficSummaries || []);
    }).catch(err => {
      console.error("Prefetch Traffic Error:", err);
      trafficCache.trafficPromise = null;
      throw err;
    });
  }

  return {
    sensorsPromise: trafficCache.sensorsPromise,
    trafficPromise: trafficCache.trafficPromise,
  };
};